// removed by extract-text-webpack-plugin
module.exports = {"password-label":"password-label___28D0q","label":"label___tsG4d","icon":"icon___1Le0b","eye":"eye___1z1hl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PasswordInput/PasswordInput.scss
// module id = Mz5s
// module chunks = 57